// @flow

import React from 'react';

import BaseComponent from '../lib/base-component';

export default class extends BaseComponent {
  static _type = 'Page';
  _type = 'Page';

  render() {
    const children = this.processChildren();

    return (
      <div>
        {children}
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/fitbit-components/page.js